// src/app/shared/services/http-utils.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class HttpUtilsService {
  
  constructor(private translateService: TranslateService) {}

  cleanParams(params: { [key: string]: any }): { [key: string]: any } {
    return Object.keys(params).reduce((cleanedParams, key) => {
      const value = params[key];
      if (
        value !== undefined &&
        value !== null &&
        value !== '' &&
        value !== false &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        cleanedParams[key] = value;
      }
      return cleanedParams;
    }, {} as { [key: string]: any });
  }


  extractErrorsList(error: any): string {
    const errorsArray = error?.error?.errors;

    if (Array.isArray(errorsArray) && errorsArray.length > 0) {
      return errorsArray.map(err => err.description).join('::');
    } else if (errorsArray.errorMessage) {
      return errorsArray.errorMessage;
    }

    return this.translateService.instant('APP.AppErrmsg_Systemerroroccured', {
      Default: 'System error occurred',
    });
  }

}
